import "./LeftSideBar.scss";
import LeftMenuButton from "./LeftMenuButton";
import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import useAuthStore from "../../store/authStore";
import ToolTip from "../ToolTip/ToolTip";
import Modal from "../Modal/Modal";
import BugReportModal from "./BugReportModal/BugReportModal";

function LeftSideBar({ onClosePostIts, onTogglePostIts, isPostItsOpen }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [activePage, setActivePage] = useState("dashboard");
  const { user, organizations, projects, currentProject } = useAuthStore();
  const toolTipRef = useRef();
  const modalRef = useRef();

  const userId = user?._id || user?.id;

  const isSuperAdmin = user?.role === "superAdmin";

  // Check if user is admin in ANY organization
  const isAdminInAnyOrg = organizations.some((org) => {
    const member = org?.members?.find(
      (m) => String(m.userId) === String(userId),
    );
    return member?.role === "admin";
  });

  // Check if user has any projects - use store's projects array or currentProject
  const hasAnyProjects =
    (projects && projects.length > 0) || currentProject !== null;

  // Show dashboard if user is admin in any org AND has at least one project
  // Check across ALL organizations, not just current one
  const showDashboard = isAdminInAnyOrg && hasAnyProjects;

  // useEffect(() => {
  // }, [user, isSuperAdmin]);

  useEffect(() => {
    const currentPath = location.pathname.replace("/", "");
    setActivePage(currentPath || "tasks");
  }, [location]);

  const handlePageButtonClick = (page) => {
    navigate(page);
  };

  const showToolTip = (e, arrow, content) => {
    const triggerElement = e.currentTarget;

    if (toolTipRef.current) {
      toolTipRef.current.open({
        arrow,
        content,
        triggerElement,
      });
    }
  };

  const openModal = (e, arrow, content) => {
    const triggerElement = e.currentTarget;

    if (modalRef.current) {
      modalRef.current.open({
        arrow,
        content,
        triggerElement,
      });
    }
  };

  return (
    <div className="left-side-bar" onClick={onClosePostIts}>
      <ToolTip ref={toolTipRef} />
      <Modal ref={modalRef} />

      <div className="menu-buttons">
        {isSuperAdmin && (
          <LeftMenuButton
            isActive={activePage === "superdashboard"}
            onClick={() => handlePageButtonClick("superdashboard")}
            page="superdashboard"
            tooltip={t("topBar.pages.superdashboard")}
          />
        )}
        {showDashboard && (
          <LeftMenuButton
            isActive={activePage === "dashboard"}
            onClick={() => handlePageButtonClick("dashboard")}
            page="dashboard"
          />
        )}
        <LeftMenuButton
          isActive={activePage === "my-day"}
          onClick={() => handlePageButtonClick("my-day")}
          icon="today"
          tooltip={t("myDay.title")}
          size="20px"
        />
        <LeftMenuButton
          isActive={activePage === "tasks"}
          onClick={() => handlePageButtonClick("tasks")}
          page="tasks"
        />
        <LeftMenuButton
          isActive={activePage === "notes"}
          onClick={() => handlePageButtonClick("notes")}
          page="notes"
        />
        <LeftMenuButton
          isActive={activePage === "project-lists"}
          onClick={() => handlePageButtonClick("project-lists")}
          page="todolists"
          tooltip={t("sidebar.projectLists")}
        />

        <div className="menu-spacer" />

        <LeftMenuButton
          isActive={activePage === "personal-lists"}
          onClick={() => handlePageButtonClick("personal-lists")}
          page="todolists"
          tooltip={t("lists.personalListsTooltip")}
          hasTopBorder
        />

        <LeftMenuButton
          isActive={isPostItsOpen}
          onClick={(e) => {
            e.stopPropagation();
            onTogglePostIts();
          }}
          icon="note_stack"
          tooltip={t("topBar.pages.postits")}
          variant="green"
          size="25px"
        />
        {/* {isSuperAdmin && (
          <LeftMenuButton
            isActive={activePage === "demo"}
            onClick={() => handlePageButtonClick("demo")}
            page="demo"
          />
        )} */}
      </div>

      <div className="bottom-buttons">
        <div
          className={`bug-feature-button`}
          onClick={(e) =>
            openModal(
              e,
              "center-center",
              <BugReportModal onClose={() => modalRef.current?.close()} />,
            )
          }
          onMouseEnter={(e) =>
            showToolTip(e, "left-center", t("bugReport.title"))
          }
        >
          <span
            className="material-symbols-outlined"
            style={{ fontSize: "20px" }}
          >
            bug_report
          </span>
        </div>
        <div
          className={`help-button ${activePage === "help" ? "active" : ""}`}
          onClick={() => handlePageButtonClick("help")}
          onMouseEnter={(e) =>
            showToolTip(e, "left-center", t("topBar.pages.help"))
          }
        >
          <span
            className="material-symbols-outlined"
            style={{ fontSize: "20px" }}
          >
            help
          </span>
        </div>
      </div>
    </div>
  );
}

export default LeftSideBar;
